import { call, put, takeEvery } from 'redux-saga/effects';
import { REMOVE_USER_EMAIL_REQUEST } from '../../constants/user_emails.constants';
import { removeUserEmail } from '../../../requests/user_emails_requests/remove_user_email_request';
import { removeUserEmailRequestSuccess, removeUserEmailRequestFailure } from '../../actions/user_emails_actions/remove_user_email.actions';
import { message_success, message_error } from '../../../../../../components/Message';

function* removeUserAddressRequest({ email_id, user_id }) {
    const {
        result, options, msg, error,
    } = yield call(removeUserEmail, email_id, user_id);
    if (result) {
        yield put(removeUserEmailRequestSuccess(options.person.emails));
        message_success('Email removed successfully!');
    } else {
        yield put(removeUserEmailRequestFailure(error));
        message_error(msg);
    }
}

export default function* removeUserEmailSaga() {
    yield takeEvery(REMOVE_USER_EMAIL_REQUEST, removeUserAddressRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_emails_sagas/remove_user_email.saga.js